import { forwardRef } from "react";
import { cn } from "@/lib/utils/cn";

export interface CardProps {
  children: React.ReactNode;
  padding?: "none" | "sm" | "md" | "lg";
  className?: string;
}

const paddingStyles = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { children, padding = "md", className },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "bg-white rounded-xl border border-gray-200",
        paddingStyles[padding],
        className,
      )}
    >
      {children}
    </div>
  );
});
